import { render, staticRenderFns } from "./AppNavbar.vue?vue&type=template&id=12f08cb9"
import script from "./AppNavbar.vue?vue&type=script&lang=ts"
export * from "./AppNavbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports